import isProduction from './standalone/isProduction.ts'
import { siteConfig } from './util/siteConfig.ts'

const Config = {
  tokenStorage: {},
  cookieName: 'CHEGGUSERTOKEN',
  accessTokenCookie: 'CHEGGUSERACCESSTOKEN',
  init(config) {
    Object.assign(this, config)
  },
  setEditorBaseUrl(url) {
    this.editorBaseUrl = url
  },
  getOnUploadSuccess() {
    return this.onUploadSuccess
  },
  setOnUploadSuccess(func) {
    this.onUploadSuccess = func
  },
  getOnAuthUpdate() {
    return this.onAuthUpdate
  },
  setOnAuthUpdate(func) {
    this.onAuthUpdate = func
  },
  getAuthApiUrl() {
    return this.authApiUrl
  },
  setAuthApiUrl(url) {
    this.authApiUrl = url
  },
  setSite(site) {
    this.site = site
  },
  getSite() {
    return this.site
  },
  setWtaiUploadUrl(url) {
    this.wtaiUploadUrl = url
  },
  getUploadUrl() {
    if (this.wtaiUploadUrl) {
      return this.wtaiUploadUrl
    }
    return siteConfig(this.site, !isProduction()).uploadUrl
  },
  setWtaiExpressUrl(url) {
    this.wtaiExpressUrl = url
  },
  getWtaiExpressUrl() {
    if (this.wtaiExpressUrl) {
      return this.wtaiExpressUrl
    }
    return siteConfig(this.site, !isProduction()).wtaiExpressUrl
  },
  getCookieDomain() {
    return siteConfig(this.site, !isProduction()).cookieDomain
  },
}

export default Config
